(() => {
  'use strict';
  const configNode = document.getElementById('afa-favorites-config');
  if (!configNode || window.afaFavoritesReady) return;
  window.afaFavoritesReady = true;
  const config = JSON.parse(configNode.textContent);
  const text = config.texts;
  const root = (config.root || '/').replace(/\/?$/, '/');
  const key = 'afa_favorites_v1';
  const limit = 100;
  const cache = new Map();
  const panel = document.querySelector('[data-afa-favorites-panel]');
  const list = panel?.querySelector('[data-afa-favorites-list]');
  const empty = panel?.querySelector('[data-afa-favorites-empty]');
  const status = panel?.querySelector('[data-afa-favorites-status]');
  const retry = panel?.querySelector('[data-afa-favorites-retry]');
  const toast = document.querySelector('[data-afa-favorites-toast]');
  let toastTimer;
  let revision = 0;
  let storageFailed = false;
  const validHandle = value => typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9-]{0,254}$/.test(value);
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(value)) return [];
      const seen = new Set();
      return value.filter(item => item && validHandle(item.handle) && !seen.has(item.handle) && seen.add(item.handle)).slice(0, limit).map(item => ({ handle: item.handle, title: typeof item.title === 'string' ? item.title.slice(0, 250) : item.handle }));
    } catch { storageFailed = true; return []; }
  };
  let favorites = read();
  const notify = message => {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 3800);
  };
  const has = handle => favorites.some(item => item.handle === handle);
  const replaceProduct = (message, title) => message.replace('__PRODUCT__', title);
  const updateButtons = () => {
    document.querySelectorAll('[data-afa-favorite-toggle]').forEach(button => {
      const saved = has(button.dataset.favoriteHandle);
      const title = button.dataset.favoriteTitle || '';
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', replaceProduct(saved ? text.removeProduct : text.addProduct, title));
      button.title = saved ? text.remove : text.add;
      const label = button.querySelector('[data-afa-favorite-label]');
      if (label) label.textContent = saved ? text.saved : text.add;
    });
    document.querySelectorAll('[data-afa-favorites-count]').forEach(node => {
      node.textContent = String(favorites.length);
      node.hidden = favorites.length === 0;
    });
  };
  const store = (next, message, redraw = true) => {
    try {
      localStorage.setItem(key, JSON.stringify(next));
      favorites = next;
      storageFailed = false;
    } catch { storageFailed = true; notify(text.storageFailed); return false; }
    updateButtons();
    if (redraw) render();
    notify(message);
    return true;
  };
  const toggle = button => {
    const handle = button.dataset.favoriteHandle;
    if (!validHandle(handle)) return;
    favorites = read();
    if (storageFailed) { notify(text.storageFailed); return; }
    if (has(handle)) store(favorites.filter(item => item.handle !== handle), text.removed);
    else {
      if (favorites.length >= limit) { notify(text.limit); return; }
      store([...favorites, { handle, title: (button.dataset.favoriteTitle || handle).slice(0, 250) }], text.added);
    }
  };
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  const loadProduct = handle => {
    if (cache.has(handle)) return cache.get(handle);
    const pending = (async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(productUrl(handle) + '.js', { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (response.status === 404 || response.status === 410) return { missing: true };
        if (!response.ok) throw new Error('product');
        const product = await response.json();
        if (!product || typeof product.title !== 'string' || !Array.isArray(product.variants)) throw new Error('product');
        return { product };
      } catch { cache.delete(handle); return { failed: true }; }
      finally { clearTimeout(timer); }
    })();
    cache.set(handle, pending);
    return pending;
  };
  const money = amount => new Intl.NumberFormat(config.locale || 'nl', { style: 'currency', currency: window.Shopify?.currency?.active || config.currency || 'EUR' }).format(amount / 100);
  const card = (item, result) => {
    const product = result.product;
    const node = element('li', 'afa-favorites__card');
    node.dataset.favoriteCard = item.handle;
    if (product?.featured_image) {
      const imageLink = element('a', 'afa-favorites__image');
      imageLink.href = productUrl(item.handle);
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      try {
        const source = new URL(product.featured_image, location.origin);
        if (source.protocol === 'https:') {
          source.searchParams.set('width', '440');
          const image = element('img');
          image.src = source.href;
          image.alt = '';
          image.width = 440;
          image.height = 440;
          image.loading = 'lazy';
          imageLink.append(image);
          node.append(imageLink);
        }
      } catch {}
    }
    const heading = element('h2');
    const title = product?.title || item.title;
    if (product) {
      const link = element('a', '', title);
      link.href = productUrl(item.handle);
      heading.append(link);
    } else heading.textContent = title;
    node.append(heading);
    if (product && Number.isFinite(product.price_min)) node.append(element('p', 'afa-favorites__price', (product.price_varies ? text.from + ' ' : '') + money(product.price_min)));
    node.append(element('p', 'afa-favorites__availability', result.failed ? text.loadFailed : result.missing ? text.unavailable : product.available ? text.available : text.soldOut));
    const actions = element('div', 'afa-favorites__actions');
    if (product) {
      const view = element('a', 'afa-account-action', text.view);
      view.href = productUrl(item.handle);
      actions.append(view);
    }
    const remove = element('button', 'afa-favorites__remove', text.remove);
    remove.type = 'button';
    remove.dataset.afaFavoriteRemove = item.handle;
    remove.setAttribute('aria-label', replaceProduct(text.removeProduct, title));
    actions.append(remove);
    node.append(actions);
    return node;
  };
  const visible = () => panel && !panel.closest('[data-afa-account-panel]')?.hidden;
  async function render() {
    if (!visible()) return;
    const current = ++revision;
    list.replaceChildren();
    retry.hidden = true;
    empty.hidden = favorites.length !== 0;
    status.textContent = storageFailed ? text.storageFailed : favorites.length ? text.loading : '';
    if (!favorites.length) return;
    const snapshot = favorites.slice().reverse();
    const slots = snapshot.map(item => {
      const slot = element('li', 'afa-favorites__card', item.title);
      list.append(slot);
      return slot;
    });
    let cursor = 0;
    let failures = false;
    await Promise.all(Array.from({ length: Math.min(4, snapshot.length) }, async () => {
      while (cursor < snapshot.length) {
        const index = cursor++;
        const result = await loadProduct(snapshot[index].handle);
        if (current !== revision) return;
        failures ||= Boolean(result.failed);
        slots[index].replaceWith(card(snapshot[index], result));
      }
    }));
    if (current !== revision) return;
    status.textContent = failures ? text.loadFailed : (snapshot.length === 1 ? text.countOne : text.count).replace('__COUNT__', String(snapshot.length));
    retry.hidden = !failures;
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-afa-favorite-toggle]');
    if (button) { event.preventDefault(); event.stopPropagation(); toggle(button); return; }
    const remove = target?.closest('[data-afa-favorite-remove]');
    if (remove) {
      const handle = remove.dataset.afaFavoriteRemove;
      const index = favorites.slice().reverse().findIndex(item => item.handle === handle);
      favorites = read();
      if (store(favorites.filter(item => item.handle !== handle), text.removed, false)) {
        render().then(() => {
          const buttons = list.querySelectorAll('[data-afa-favorite-remove]');
          (buttons[Math.min(index, buttons.length - 1)] || panel.querySelector('a'))?.focus();
        });
      }
    }
  });
  retry?.addEventListener('click', () => render());
  window.addEventListener('hashchange', () => render());
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    storageFailed = false;
    favorites = read();
    updateButtons();
    render();
  });
  const observer = new MutationObserver(changes => {
    if (changes.some(change => Array.from(change.addedNodes).some(node => node instanceof Element && (node.matches('[data-afa-favorite-toggle]') || node.querySelector('[data-afa-favorite-toggle]'))))) updateButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', updateButtons);
  updateButtons();
  render();
})();
